import './basket.scss';
import Selectr from 'Selectr';
import { AjaxLoader } from '../../js/ajax-loader';
import { createElementFromHTML, smoothScrollTo, getOffset } from '../../js/helper';

class Basket {
    constructor (element) {
        this.$basket = element;
        this.$form = this.$basket.querySelector('form');
        this.$results = this.$basket.querySelector('[data-basket="results"]');
        this.$$selects = this.$basket.querySelectorAll('[data-select]');
        this.selectbox = [];
        this.$tagList = this.$basket.querySelector('[data-bp-filter="taglist"]');
        this.$counter = this.$basket.querySelector('[data-basket="counter"]');
        this.$mobileCounter = this.$basket.querySelector('[data-bp-filter-mobile-count]');
        this.$resetButton = this.$basket.querySelector('[data-bp-filter="reset"]');
        this.$deleteSeletionButton = this.$basket.querySelector('[data-basket-delete="selection"]');
        this.$deleteAllButton = this.$basket.querySelector('[data-basket-delete="all"]');
        this.$overlay = this.$basket.querySelector('[data-basket-overlay]');
        this.$overlayType = this.$overlay.querySelector('[data-basket-overlay-type]');
        this.$basketStart = this.$basket.querySelector('[data-basket="start"]');
        this.$downloadAllButton = this.$basketStart.querySelector('[data-basket-download-all]');

        this.$filterClose = this.$form.querySelector('[data-bp-filter="filter-close"]');
        this.$$filterCheckbox = this.$basket.querySelectorAll('[data-bp-filter="filter-checkbox"]');
        this.$filterBar = this.$form.querySelector('[data-bp-filter="filterbar"]');
        this.$viewButton = this.$form.querySelector('[data-bp-filter="view-button"]');

        this.$pagination = this.$basket.querySelector('[data-basket="pagination"]');
        this.$page = this.$basket.querySelector('[data-basket="page"]');

        this.selectedDeleteInputs = 0;
        this.resetActive = false;
        this.allowSubmit = true;
        this.lastActiveSelect = null;
        this.pager = null;

        this.publicBasket = publicBasket; // eslint-disable-line
        this.dtswissBasket = dtswissBasket; // eslint-disable-line
        this.deleteType = '';
        this.noScrolling = false;

        this.timerCount = 1000;
        this.timer = null;
    }

    initialize () {
        this.handleSelect(this.$$selects);
        if (!this.publicBasket) {
            this.setAssetEvents();
            smoothScrollTo(0, (getOffset(this.$basketStart).top - 70));
        }

        this.checkSelects();
        this.setResetButton(this.resetActive);
        this.handlePager();

        if (this.publicBasket) {
            this.loadPublicBasket();
        } else if (!this.dtswissBasket && JSON.parse(localStorage.getItem('basket'))) {
            this.loadPublicBasket();
        }

        this.setEvents();
        this.setInitialEvents();
    }

    // set general events
    setEvents () {
        [this.$filterClose, this.$viewButton].forEach((element) => {
            element.addEventListener('click', () => {
                const $activeFilterCheckbox = this.$basket.querySelector('[data-bp-filter="filter-checkbox"]:checked');

                if ($activeFilterCheckbox) {
                    $activeFilterCheckbox.checked = false;
                }
            });
        });

        this.$$filterCheckbox.forEach((filterCheckbox) => {
            filterCheckbox.addEventListener('change', () => {
                if (filterCheckbox.checked) {
                    const $activeCheckbox = this.$basket.querySelector('[data-bp-filter="filter-checkbox"]:checked:not([id="' + filterCheckbox.getAttribute('id') + '"])');
                    if ($activeCheckbox) {
                        $activeCheckbox.checked = false;
                    }
                }
            });
        });

        if (!this.publicBasket) {
            this.setLoggedInDownloadEvent();
        }

        if (this.$deleteSeletionButton) {
            this.$deleteSeletionButton.addEventListener('click', () => {
                this.deleteType = 'single';
                this.$overlayType.setAttribute('data-basket-overlay-type', this.deleteType);
                this.$overlay.classList.add('is--visible');
            });
        }

        if (this.$deleteAllButton) {
            this.$deleteAllButton.addEventListener('click', () => {
                this.deleteType = 'all';
                this.$overlayType.setAttribute('data-basket-overlay-type', this.deleteType);
                this.$overlay.classList.add('is--visible');
            });
        }
    }

    setAssetEvents () {
        this.$$assetDeleteInputs = this.$results.querySelectorAll('[data-basket-asset="delete"]');

        if (this.$$assetDeleteInputs.length > 0) {
            if (!this.$results.querySelector('[data-basket-asset="delete"]:checked')) {
                this.$deleteSeletionButton.classList.add('is--hidden');
                this.selectedDeleteInputs = 0;
            }

            this.$$assetDeleteInputs.forEach((deleteInput) => {
                deleteInput.addEventListener('change', () => {
                    if (deleteInput.checked) {
                        this.selectedDeleteInputs += 1;
                    } else {
                        this.selectedDeleteInputs -= 1;
                    }

                    if (this.selectedDeleteInputs === 0) {
                        this.$deleteSeletionButton.classList.add('is--hidden');
                    } else {
                        this.$deleteSeletionButton.classList.remove('is--hidden');
                    }
                });
            });
        }
    }

    setInitialEvents () {
        this.$resetButton.addEventListener('click', () => {
            this.setResetButton(false);
            this.resetFilter();
        });

        this.$overlay.addEventListener('click', (e) => {
            if (e.target.getAttribute('data-basket-delete') === 'close') {
                this.$overlay.classList.remove('is--visible');
            }

            if (e.target.getAttribute('data-basket-delete') === 'confirm') {
                this.$overlay.classList.remove('is--visible');
                /* toDo: Check if no Products (results.total_count = 0 left and reload page */
                if (this.publicBasket) {
                    this.deleteLocalItems(this.deleteType);
                } else {
                    this.waitAndSubmit();
                }
            }
        });
    }

    deleteLocalItems (deleteType) {
        if (deleteType === 'single') {
            const $$selectedItems = this.$basket.querySelectorAll('[data-basket-asset="delete"]:checked');
            const newArr = [];
            const localBasket = JSON.parse(localStorage.getItem('basket'));

            for (const item of localBasket) {
                let set = true;

                for (const selectedItem of $$selectedItems) {
                    const data = selectedItem.value.split('_');

                    if (item.id === parseInt(data[1])) {
                        if (item.type === data[0].toString()) {
                            set = false;
                        }
                    } else {
                        set = true;
                    }
                    if (set === false) {
                        break;
                    }
                }

                if (set === true) {
                    newArr.push(item);
                }
                set = true;
            }

            if (newArr.length > 0) {
                localStorage.setItem('basket', JSON.stringify(newArr));
                this.loadPublicBasket();
            } else {
                localStorage.removeItem('basket');
                window.location.reload();
            }
        } else if (deleteType === 'all') {
            localStorage.removeItem('basket');
            window.location.reload();
        }
    }

    // reset all selectFilter and submit
    resetFilter () {
        this.allowSubmit = false;
        for (let index = 0; index < this.selectbox.length; index++) {
            this.selectbox[index].options.forEach((option) => {
                if (this.selectbox[index].originalType === 'select-one') {
                    if (option.getAttribute('data-default-selected') !== null && option.selected !== true) {
                        this.selectbox[index].setValue(option.value);
                    }
                } else {
                    if (option.selected === true) {
                        this.selectbox[index].setValue(option.value);
                    }
                }
            });
        }
        this.allowSubmit = true;
        this.lastActiveSelect = null;
        this.waitAndSubmit();
    }

    // set resetbutton active or deactive
    setResetButton (reset) {
        if (reset === true) {
            this.$resetButton.classList.add('is--active');
            this.resetActive = true;
        } else {
            this.$resetButton.classList.remove('is--active');
            this.resetActive = false;
        }
    }

    // check available selectFilter and set Tags (multi-select) or special Placeholder (single-select)
    checkSelects () {
        for (let index = 0; index < this.selectbox.length; index++) {
            if (this.selectbox[index].originalType === 'select-multiple') {
                this.setTagsFromFilter(this.selectbox[index]);
            } else {
                this.setSortLabel(this.selectbox[index]);
            }
        }
    }

    // check options per select and set reset and tags
    setTagsFromFilter (select) {
        select.options.forEach((option) => {
            if (option.selected === true) {
                this.resetActive = true;
                this.setFilter(option.innerText);
            }
        });
    }

    // set single-select (sorting) icon
    setSortLabel (select) {
        select.options.forEach((option) => {
            if (option.selected === true) {
                const $label = option.closest('.selectr-container').firstElementChild.firstElementChild;
                const icon = option.getAttribute('data-icon');

                if (icon === 'icon-sorting_z-a') {
                    $label.classList.remove('icon-sorting_a-z');
                    this.resetActive = true;
                } else {
                    $label.classList.remove('icon-sorting_z-a');
                }

                $label.classList.add(option.getAttribute('data-icon'));
            }
        });
    }

    // handler for all selectFilter. Use selectr and set events
    handleSelect ($selects) {
        Object.defineProperty(Selectr.prototype, 'mobileDevice', {
            get () { return false; },
            set () {},
            enumerable: true,
            configurable: true
        });

        $selects.forEach(($select, index) => {
            this.selectbox[index] = new Selectr($select, {
                defaultSelected: false,
                searchable: false,
                clearable: false,
                multiple: true,
                nativeDropdown: false,
                placeholder: $select.getAttribute('data-placeholder'),
                taggable: false
            });

            if (this.lastActiveSelect !== '') {
                if (this.lastActiveSelect === $select.getAttribute('name')) {
                    this.selectbox[index].open();
                }
            }

            this.selectbox[index].on('selectr.close', () => {
                this.lastActiveSelect = '';
            });

            this.selectbox[index].on('selectr.select', (option) => {
                this.setFilter(option.innerText, () => {
                    this.lastActiveSelect = $select.getAttribute('name');
                    this.setResetButton(true);
                    this.waitAndSubmit();
                });
            });

            this.selectbox[index].on('selectr.deselect', (option) => {
                this.removeFilter(option.innerText, () => {
                    this.lastActiveSelect = $select.getAttribute('name');
                    if (this.allowSubmit) {
                        this.waitAndSubmit();
                    }
                });
            });
        });
    }

    // get result HTML and put it into Results
    setResults (html, append = false, count) {
        if (count > 0) {
            const $results = createElementFromHTML(html);

            if (!append) {
                this.$results.innerHTML = '';
            }

            if ($results.length > 1) {
                $results.forEach((element) => {
                    this.$results.appendChild(element);
                });
            } else {
                this.$results.appendChild($results);
            }
        } else {
            this.$results.innerHTML = '';
        }
    }

    // get result HTML and put it into Target
    setPagination (html) {
        const $pagination = createElementFromHTML(html);
        this.$pagination.innerHTML = '';

        if ($pagination) {
            this.$pagination.appendChild($pagination);
            this.handlePager();
        } else {
            this.$pagination.innerHTML = '';
        }
    }

    // get new Filters from HTML and set it as new filters
    setSelectFilter (html) {
        if (html !== null) {
            const $selectFilter = createElementFromHTML(html);
            this.$filterBar.innerHTML = '';

            if ($selectFilter.length > 1) {
                $selectFilter.forEach((element) => {
                    this.$filterBar.appendChild(element);
                });
            } else {
                this.$filterBar.appendChild($selectFilter);
            }

            const waitForPlacement = setInterval(() => {
                if (this.$filterBar.querySelector('[data-select="multiple"]')) {
                    clearInterval(waitForPlacement);
                    this.$$selects = this.$basket.querySelectorAll('[data-select]');
                    this.selectbox = [];
                    this.handleSelect(this.$$selects);
                }
            }, 10);
        } else {
            this.$filterBar.innerHTML = '';
        }
    }

    // remove filter tag if option was deselected inside select
    removeFilter (value, callback) {
        const $$tags = this.$tagList.querySelectorAll('li');

        $$tags.forEach(($tag) => {
            if ($tag.innerText === value.toUpperCase()) {
                $tag.remove();
            }
        });

        if (typeof callback === 'function') {
            callback();
        }
    }

    // set filter tag if option is selected inside select
    setFilter (value, callback) {
        const $tag = document.createElement('li');
        $tag.classList.add('bp-filter__tag');
        const $tagClose = document.createElement('span');
        $tagClose.setAttribute('data-bp-filter', 'tagclose');

        $tag.innerText = value;
        $tag.appendChild($tagClose);
        this.$tagList.appendChild($tag);

        $tagClose.addEventListener('click', () => {
            this.removeFilterByTag(value, () => {
                $tag.remove();
            });
        });

        if (typeof callback === 'function') {
            callback();
        }
    }

    // remove selected option from select if tag was removed
    removeFilterByTag (value, callback) {
        for (let index = 0; index < this.selectbox.length; index++) {
            const foundValue = this.selectbox[index].search(value);
            const arr = [];
            let found = false;

            if (foundValue.length > 0) {
                const selected = this.selectbox[index].getValue(true);

                if (selected) {
                    selected.values.forEach((item, itemIndex) => {
                        if (item.text === value) {
                            arr.push(item.value);
                            found = true;
                        }
                    });

                    if (found) {
                        this.selectbox[index].setValue(arr);
                    }
                } else {
                    console.info('Error getting selected values');
                }
            }
        }

        if (typeof callback === 'function') {
            callback();
        }
    }

    waitAndSubmit () {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.filterSubmit();
        }, this.timerCount);
    }

    // handle the ajax request if filter has changed
    filterSubmit (url) {
        if (!this.publicBasket) {
            if (this.allowSubmit) {
                if (!url) {
                    url = this.$form.getAttribute('action');
                }

                this.allowSubmit = false;

                this.$results.classList.add('is--loading');

                this.result = new AjaxLoader(url, {
                    requestMethod: this.$form.getAttribute('method'),
                    requestData: new FormData(this.$form),
                    onSuccess: (resultText) => {
                        const results = JSON.parse(resultText);
                        this.setResults(results.results.html, false, results.results.total_count);
                        this.$counter.innerHTML = results.results.total_count;
                        if (this.$mobileCounter) {
                            this.$mobileCounter.firstElementChild.firstElementChild.innerHTML = results.results.total_count;
                        }
                        this.setSelectFilter(results.listing_filter.html);
                        this.setPagination(results.pagination.html);
                        this.$results.classList.remove('is--loading');
                        this.setAssetEvents();
                        this.allowSubmit = true;

                        if (results.results.download_url) {
                            this.$downloadAllButton.href = results.results.download_url;
                            this.$downloadAllButton.removeAttribute('disabled');

                            if (this.$downloadAllButton.getAttribute('data-basket-download-all') === 'public') {
                                this.setPublicDownloadEvent();
                            } else {
                                this.setLoggedInDownloadEvent();
                            }
                        } else {
                            this.$downloadAllButton.href = '';
                            this.$downloadAllButton.setAttribute('disabled');
                        }

                        if (!this.noScrolling) {
                            smoothScrollTo(0, (getOffset(this.$basketStart).top - 70));
                        }
                        this.noScrolling = false;
                    },
                    onError: (error) => {
                        console.warn(error);
                    }
                });
            }
        } else {
            this.loadPublicBasket();
        }
    }

    setPublicDownloadEvent () {
        const localBasket = localStorage.getItem('basket');
        this.noScrolling = true;

        if (localBasket) {
            this.$downloadAllButton.addEventListener('click', (e) => {
                e.preventDefault();

                const localBasketObject = JSON.parse(localStorage.getItem('basket'));

                if (localBasketObject.length > 0) {
                    const req = new XMLHttpRequest();
                    const formData = new FormData(this.$form);
                    formData.append('public_items', localBasket.toString());

                    req.open('POST', this.$downloadAllButton.href, true);
                    req.responseType = 'blob';
                    req.onload = (event) => {
                        const blob = req.response;
                        const fileName = req.getResponseHeader('content-disposition').split('\'\'')[1];
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = fileName;
                        link.click();

                        if (this.$deleteAllButton) {
                            setTimeout(() => {
                                this.$deleteAllButton.click();
                            }, 2000);
                        }
                    };

                    req.send(formData);
                }
            });
        }
    }

    setLoggedInDownloadEvent () {
        this.$downloadAllButton.addEventListener('click', (e) => {
            this.noScrolling = true;
            e.preventDefault();

            fetch(this.$downloadAllButton.getAttribute('href'))
                .then(response => response.blob())
                .then(blob => {
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = url;
                    a.download = 'dtswiss-basket.zip';
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(url);

                    if (this.$deleteAllButton) {
                        setTimeout(() => {
                            this.$deleteAllButton.click();
                        }, 1000);
                    }
                }).catch(() => {
                    console.info('Download failed');
                });
        });
    }

    handlePager () {
        const $pager = this.$form.querySelector('[data-pager="root"]');

        if ($pager) {
            import('./../../components/pager/pager').then(({ Pager }) => {
                this.pager = true;
                this.pager = new Pager($pager);

                $pager.addEventListener('click', (e) => {
                    e.preventDefault();

                    if (e.target.getAttribute('rel') !== null) {
                        this.$basket.querySelector('[name="page"]').value = e.target.getAttribute('rel');

                        if (window.innerWidth >= 768) {
                            this.waitAndSubmit();
                        }
                    }
                });

                const addSelectrEvent = () => {
                    this.pager.$pagerSelect.selectr.on('selectr.change', () => {
                        if (window.innerWidth < 768) {
                            this.waitAndSubmit();
                        }
                    });
                };

                const waitForSelectr = setInterval(() => {
                    if (this.pager.$pagerSelect.selectr) {
                        addSelectrEvent();
                        clearInterval(waitForSelectr);
                    }
                }, 500);
            });
        }
    }

    loadPublicBasket () {
        const localBasket = localStorage.getItem('basket');

        if (localBasket) { // eslint-disable-line
            const localBasketObject = JSON.parse(localStorage.getItem('basket'));

            if (localBasketObject.length > 0) {
                const url = this.$form.getAttribute('action');
                this.allowSubmit = false;

                this.$form.classList.remove('is--hidden');
                this.$basketStart.classList.add('is--hidden');
                this.$basket.querySelector('[data-basket="start-headline"]').classList.add('is--hidden');

                this.$results.classList.add('is--loading');
                const formData = new FormData(this.$form);
                formData.append('public_items', localBasket.toString());

                this.result = new AjaxLoader(url, {
                    requestMethod: this.$form.getAttribute('method'),
                    requestData: formData,
                    onSuccess: (resultText) => {
                        const results = JSON.parse(resultText);

                        if (results.synchronized) {
                            localStorage.removeItem('basket');
                            window.location.reload();
                        } else {
                            this.setResults(results.results.html, false, results.results.total_count);
                            this.$counter.innerHTML = results.results.total_count;

                            if (this.$mobileCounter) {
                                this.$mobileCounter.firstElementChild.firstElementChild.innerHTML = results.results.total_count;
                            }

                            this.setSelectFilter(results.listing_filter.html);
                            this.setPagination(results.pagination.html);
                            this.$results.classList.remove('is--loading');
                            this.setAssetEvents();
                            this.allowSubmit = true;
                            this.$basketStart.classList.remove('is--hidden');

                            if (results.results.download_url !== null) {
                                this.$downloadAllButton.href = results.results.download_url;
                                this.$downloadAllButton.removeAttribute('disabled');

                                if (this.$downloadAllButton.getAttribute('data-basket-download-all') === 'public') {
                                    this.setPublicDownloadEvent();
                                } else {
                                    this.setLoggedInDownloadEvent();
                                }
                            } else {
                                this.$downloadAllButton.href = '';
                                this.$downloadAllButton.setAttribute('disabled', true);
                            }

                            if (!this.noScrolling) {
                                smoothScrollTo(0, (getOffset(this.$basketStart).top - 70));
                            }
                            this.noScrolling = false;
                        }
                    },
                    onError: (error) => {
                        console.warn(error);
                    }
                });
            }
        } else {
            this.$basketStart.classList.remove('is--hidden');
            this.$basket.querySelector('[data-basket="public-start-headline"]').remove();
            this.$form.classList.add('is--hidden');
            this.$basket.querySelector('[data-basket="start-headline"]').classList.remove('is--hidden');
            this.$downloadAllButton.href = '';
            this.$downloadAllButton.setAttribute('disabled', true);
        }
    }
}

export { Basket };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $basket = $context.querySelector('[data-basket="root"]');

        if ($basket) {
            const basket = new Basket($basket);
            basket.initialize();
        }
    }
});
